  (function () {
    var INSTALLED_KEY = 'florame_pwa_installed_v1';
    var INSTALLED_AT_KEY = 'florame_pwa_installed_at_v1';
    var INSTALL_MARK_TTL_MS = 30 * 24 * 60 * 60 * 1000;
    function storageGet(key) {
      try { return window.localStorage.getItem(key) || ''; } catch (_) { return ''; }
    }
    function storageRemove(key) {
      try { window.localStorage.removeItem(key); } catch (_) {}
    }
    function isStandalone() {
      try {
        return window.navigator.standalone === true || window.matchMedia('(display-mode: standalone)').matches;
      } catch (_) {
        return window.navigator.standalone === true;
      }
    }
    function isInstallMarked() {
      if (storageGet(INSTALLED_KEY) !== '1') return false;
      var installedAt = Number(storageGet(INSTALLED_AT_KEY) || 0);
      if (!isStandalone() && installedAt && Date.now() - installedAt > INSTALL_MARK_TTL_MS) {
        storageRemove(INSTALLED_KEY);
        storageRemove(INSTALLED_AT_KEY);
        return false;
      }
      return true;
    }
    function applyState() {
      var standalone = isStandalone();
      var installed = standalone || isInstallMarked();
      document.documentElement.setAttribute('data-florame-pwa-installed', installed ? '1' : '0');
      document.documentElement.setAttribute('data-florame-pwa-standalone', standalone ? '1' : '0');
    }
    applyState();
    window.addEventListener('florame:pwa-install-state', applyState);
    window.addEventListener('beforeinstallprompt', function () {
      storageRemove(INSTALLED_KEY);
      storageRemove(INSTALLED_AT_KEY);
      applyState();
    });
    window.addEventListener('pageshow', applyState);
    window.addEventListener('appinstalled', function () {
      try { window.localStorage.setItem(INSTALLED_KEY, '1'); } catch (_) {}
      try { window.localStorage.setItem(INSTALLED_AT_KEY, Date.now()); } catch (_) {}
      applyState();
    });
  })();
